import { seller } from './seller'
import { sellerInfo } from './sellerInfo'

export const sellerService = {
  seller,
  sellerInfo,
}
